import { b2x } from '@b2x/react/src';

import { t } from '../i18n/i18n';
import { customerIsVet } from '../util';

export interface AccountReferralVetSubpageProps {}

export const AccountReferralVetSubpage = () => {
  const { session } = b2x.useAppContext();

  const isVet = session?.customer?.qualifiers && customerIsVet(session.customer.qualifiers);

  return (
    <b2x.AccountSubpage<b2x.contentTypes.AccountReferralSubpageContentType>>
      {(page) => (
        <b2x.ReferralBox
          {...page.content?.body.referralBox}
          sharingOptions={{
            alternativeText: t('misc.inviteFrient.sharingOptions.alternativeText'),
            disableSharing: !isVet ? true : false,
            friendType: 'Vet',
            pageCode: 'SITE_REGISTER_VET',
          }}
        />
      )}
    </b2x.AccountSubpage>
  );
};
